import React from 'react';
import Card from './Card';
import Chart from './Chart';
import DataTable from './DataTable';
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Dashboard Overview</h1>
      
      <div className="cards-grid">
        <Card 
          title="Total Revenue" 
          value="$24,780" 
          change="+12.5%" 
          icon="dollar-sign" 
          type="primary" 
        />
        <Card 
          title="Total Users" 
          value="1,245" 
          change="+8.2%" 
          icon="users" 
          type="success" 
        />
        <Card 
          title="Total Orders" 
          value="356" 
          change="-3.1%" 
          icon="shopping-cart" 
          type="warning" 
        />
        <Card 
          title="Pending Orders" 
          value="24" 
          change="+1.8%" 
          icon="clock" 
          type="danger" 
        />
      </div>
      
      <div className="charts-row">
        <Chart title="Sales Overview" />
        <Chart title="Revenue Sources" />
      </div>
      
      <DataTable />
    </div>
  );
};

export default Dashboard;